import { COPY } from '@/shared/constants/copies';

import { ProtectedFieldLockIcon } from './protected-field-lock-icon';
import { Tooltip } from './tooltip';

interface ProtectedFieldBadgeProps {
	side?: 'top' | 'bottom' | 'left' | 'right';
}

export function ProtectedFieldBadge({ side = 'top' }: ProtectedFieldBadgeProps) {
	return (
		<Tooltip
			delayDuration={300}
			content={COPY.fields.protectedBadge}
			side={side}
		>
			<span className="inline-flex shrink-0 items-center text-amber-600">
				<ProtectedFieldLockIcon className="size-3.5" />
			</span>
		</Tooltip>
	);
}
